/**
 * 前端Storage工具类作了简单封装：
 * 1、目前使用sessionStorage来存储登录信息（登录状态、登录用户、Token信息等）；
 * 2、如需使用localStorage来存储则统一在这里调整即可；
 */
  var Storage = {
    timeKey:"hrsaas-timestamp-key",
    flag: false,//flag?Storage:localStorage
    getStorage: function () {
      return this.flag ? window.sessionStorage : window.localStorage;
    },
    setItem: function (key, value) {
      this.getStorage().setItem(key, JSON.stringify(value));
    },
    getItem: function (key) {
      return JSON.parse(this.getStorage().getItem(key));
    },
    removeItem: function (key) {
      this.getStorage().removeItem(key);
    },
    removeAll: function () {
      this.getStorage().clear();
    },
    getLoginUser: function () {
      return this.getItem("loginInfo").userInfo;
    },
    getTimeStamp(){
      return this.getStorage().getItem(this.timeKey)
    },
    setTimeStamp(){
      this.getStorage().setItem(this.timeKey, Date.now())
    }
  }
  
  export default Storage